import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

const StyledRarelyViewedBadge = styled.div`
  display: block;
  width: 82px;
  height: 16px;
  border-radius: 100px;

  padding: 2px 5px 3px 5px;
  margin-left: 4px;
  margin-right: 2px;

  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.veryTiny};
  color: ${(p) => p.theme.p1RarelyViewedBadgeText};
  background-color: ${(p) => p.theme.p1RarelyViewedBadgeBackground};
`;

const StyledDiv = styled.div`
  margin-left: auto;
  align-content: right;
`;

/*
 * Component.
 */

export const WorkspacesEditorRarelyViewedBadge: FC = () => (
  <StyledDiv>
    <StyledRarelyViewedBadge>
      <Trans id="workspaces-autorec-rarelyviewed">Rarely viewed</Trans>
    </StyledRarelyViewedBadge>
  </StyledDiv>
);
